import script from "./FormalOpen.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormalOpen.vue?vue&type=script&lang=ts&setup=true"

import "./FormalOpen.vue?vue&type=style&index=0&id=cc315010&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc315010"]])

export default __exports__